/* AEXR theme scripts */
(function () {
  'use strict';

  var T = window.theme || {};
  var strings = T.strings || {};

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html) {
    var el = qs('#Toast');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4500);
  }

  /* ---------- Cart count ---------- */
  function updateCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
        return cart;
      });
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();

    var btn = qs('[data-add-btn]', form);
    if (btn && btn.classList.contains('is-loading')) return;
    if (btn) btn.classList.add('is-loading');

    fetch(T.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || strings.error);
        return updateCartCount().then(function () {
          toast(strings.added + ' &middot; <a href="' + (T.cartUrl || '/cart') + '">' + strings.viewCart + '</a>');
        });
      })
      .catch(function (err) {
        toast(err && err.message ? err.message : strings.error);
      })
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    var wrap = b.closest('.qty');
    var input = qs('input', wrap);
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    val += b.getAttribute('data-qty-btn') === 'plus' ? 1 : -1;
    if (val < min) val = min;
    if (!isNaN(max) && val > max) val = max;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Cart page: auto submit when qty changes
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var form = input.closest('form');
    if (form) {
      clearTimeout(input._t);
      input._t = setTimeout(function () {
        var upd = qs('[name="update"]', form);
        if (upd) upd.click(); else form.submit();
      }, 350);
    }
  });

  /* ---------- Drawer ---------- */
  var drawer = qs('#MobileDrawer');
  function toggleDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-drawer]')) toggleDrawer(true);
    if (e.target.closest('[data-close-drawer]')) toggleDrawer(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { toggleDrawer(false); qsa('.filters.is-open').forEach(function (f) { f.classList.remove('is-open'); }); }
  });

  /* ---------- Collection filters ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle-filters]');
    if (!t) return;
    var f = qs('#Filters');
    if (f) f.classList.toggle('is-open');
  });
  var filterForm = qs('#FilterForm');
  if (filterForm) {
    filterForm.addEventListener('change', function () { filterForm.submit(); });
  }
  var sortSelect = qs('#SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var jsonEl = qs('[data-product-json]', root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = qs('form[data-product-form]', root);
    var idInput = qs('[name="id"]', form);
    var btn = qs('[data-add-btn]', form);
    var btnLabel = qs('[data-add-label]', btn);
    var priceEl = qs('[data-price]', root);
    var stickyBtn = qs('[data-sticky-btn]');
    var stockEl = qs('[data-stock]', root);
    var skuEl = qs('[data-sku]', root);
    var moneyFmt = function (cents) {
      var v = (cents / 100).toFixed(2);
      var fmt = T.moneyFormat || '${{amount}}';
      var parts = v.split('.');
      var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/, withComma + '.' + parts[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    };

    function currentOptions() {
      var opts = [];
      qsa('[data-option]', root).forEach(function (group) {
        var i = parseInt(group.getAttribute('data-option'), 10);
        var checked = qs('input:checked', group);
        var select = qs('select', group);
        opts[i] = checked ? checked.value : (select ? select.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    }

    function setActiveMedia(id) {
      if (!id) return;
      var slide = qs('[data-media-id="' + id + '"]', root);
      if (slide) showSlide(slide.getAttribute('data-index'));
    }

    function update() {
      var v = findVariant(currentOptions());
      if (!v) {
        btn.setAttribute('disabled', 'disabled');
        btnLabel.textContent = strings.unavailable;
        return;
      }
      idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = '<span class="price__current">' + moneyFmt(v.price) + '</span>' +
          (v.compare_at_price > v.price ? ' <s class="price__compare">' + moneyFmt(v.compare_at_price) + '</s>' : '');
        priceEl.classList.toggle('price--sale', v.compare_at_price > v.price);
      }
      if (v.available) {
        btn.removeAttribute('disabled');
        btnLabel.textContent = strings.addToCart;
        if (stockEl) { stockEl.textContent = 'In stock'; stockEl.className = 'stock'; }
      } else {
        btn.setAttribute('disabled', 'disabled');
        btnLabel.textContent = strings.soldOut;
        if (stockEl) { stockEl.textContent = 'Out of stock'; stockEl.className = 'stock stock--out'; }
      }
      if (stickyBtn) { stickyBtn.disabled = !v.available; }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (v.featured_media) setActiveMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option]')) update();
    });

    /* gallery */
    var slides = qsa('.gallery__slide', root);
    var thumbs = qsa('.gallery__thumb', root);
    function showSlide(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', String(n) === String(i)); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', String(n) === String(i)); });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { showSlide(n); }); });

    /* sticky mobile bar submits the main form */
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }
  qsa('[data-product]').forEach(initProduct);
})();
